import { TeamMembersRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

/**
 * The table state this route adds on top of any params it passes through. All of it is written
 * and read by `useTeamMembersTableState` (nuqs), so a filtered view is shareable and survives a
 * refresh; declared here so typed `Link`s can preselect a view. The parsers there bound each
 * value, so only `type` needs refining at the route level.
 */
type TeamMembersSearch = {
  /**
   * Preselects the row-kind filter (the "Show" dropdown), so a link can open
   * the page already scoped to pending join requests or guests.
   */
  type?: 'join-request' | 'guest';
  /** Workspace filter — a workspace id, or absent for all workspaces. */
  workspace?: string;
  /** The committed search term (the uncommitted input stays out of the URL). */
  search?: string;
  /** 1-based page of the users index. */
  page?: number;
  /** Sorted column id, as the users index expects it. */
  sort?: string;
  /** Sort direction: `true` ascending, absent/`false` descending. */
  asc?: boolean;
};

export const Route = createFileRoute('/_authenticated/settings/team/')({
  component: TeamMembersRoute,
  // validateSearch replaces this route's search, so spread the incoming params
  // to preserve global ones the page doesn't own (masq_account_id, cmd-search,
  // …, all read from window.location) and only refine `type`.
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & TeamMembersSearch => ({
    ...search,
    type: search.type === 'join-request' || search.type === 'guest' ? search.type : undefined,
  }),
});
